(() => {
  const main = document.getElementById('MainContent');
  if (!main || window.Shopify?.designMode) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.luma3-feature-01__feature,.luma-info-plus-3-feature-01__feature,.luma-frame-grid__card,.luma-reseller-cta__content,.luma-reseller-cta__logos-column,.luma3-feature-01__heading,.luma-info-plus-3-feature-01__heading,.luma-frame-grid__heading,[data-feature-reveal],.luma-5-pro-standalone__content,.luma-5-pro-standalone__image,.luma-5-pro-standalone__video,.luma-hero-tech-02__text,.luma-hero-tech-02__image--desktop,.luma-hero-tech-02__image--mobile,.luma-hero-cta__main-reveal,.luma-hero-cta__secondary-reveal,.dual-marquee__ribbon,.luma-trust__item,.featured-items-pro__item--reveal';
  const items = [...main.querySelectorAll(selector)];
  main.querySelectorAll('.scroll-trigger').forEach(item => {
    if (!item.querySelector(selector) && !item.closest(selector)) items.push(item);
  });
  if (!items.length) return;
  main.querySelectorAll('.luma-5-pro-standalone,.luma-hero-tech-02,[id^="DualMarquee-"]').forEach(item => item.classList.add('is-revealed'));
  main.querySelectorAll('.luma-hero-cta__section').forEach(item => item.classList.add('is-visible'));
  const targets = items.map(item => {
    const staggered = item.matches('.luma3-feature-01__feature,.luma-info-plus-3-feature-01__feature,.luma-frame-grid__card,[data-feature-reveal],.luma-trust__item,.featured-items-pro__item--reveal');
    const index = staggered ? [...item.parentElement.children].filter(child => child.matches(selector)).indexOf(item) : 0;
    item.classList.add('luma-scroll-reveal-item');
    item.style.setProperty('--luma-reveal-x', item.matches('[data-feature-reveal]') ? '-32px' : '0px');
    item.style.setProperty('--luma-reveal-y', item.matches('[data-feature-reveal],.dual-marquee__ribbon') ? '0px' : '28px');
    if (item.matches('.dual-marquee__ribbon')) item.style.setProperty('--luma-reveal-x', item.matches('.dual-marquee__ribbon--one') ? '-48px' : '48px');
    return { item, index: Math.max(index, 0), top: 0 };
  });
  main.classList.add('luma-scroll-reveals');
  let frame = 0;
  let measuring = true;
  const update = () => {
    frame = 0;
    if (measuring) {
      targets.forEach(({item}) => item.style.setProperty('--luma-reveal-progress', '1'));
      targets.forEach(target => { target.top = target.item.getBoundingClientRect().top + window.scrollY; });
      measuring = false;
    }
    const span = Math.max(100, Math.min(220, window.innerHeight * 0.25));
    targets.forEach(({item, index, top}) => {
      const focused = item.contains(document.activeElement);
      const progress = motion.matches || focused ? 1 : Math.max(0, Math.min(1, (window.scrollY + window.innerHeight * 0.95 - top - index * 28) / span));
      item.style.setProperty('--luma-reveal-progress', progress.toFixed(4));
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', () => { measuring = true; schedule(); }, { passive: true });
  window.addEventListener('load', () => { measuring = true; schedule(); });
  document.fonts?.ready.then(() => { measuring = true; schedule(); });
  motion.addEventListener('change', schedule);
  main.addEventListener('focusin', schedule);
  main.addEventListener('focusout', schedule);
  window.addEventListener('beforeprint', () => targets.forEach(({item}) => item.style.setProperty('--luma-reveal-progress', '1')));
  window.addEventListener('afterprint', schedule);
  if ('ResizeObserver' in window) new ResizeObserver(() => { measuring = true; schedule(); }).observe(main);
  update();
})();
